import { render, staticRenderFns } from "./MobileAnalisiMenu.vue?vue&type=template&id=920810b0&scoped=true&"
import script from "./MobileAnalisiMenu.vue?vue&type=script&lang=js&"
export * from "./MobileAnalisiMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileAnalisiMenu.vue?vue&type=style&index=0&id=920810b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920810b0",
  null
  
)

export default component.exports